import {Injectable} from '@angular/core';
import {Actions, ApiEndpoints} from '../constants/ApiEndpoints';
import {RequestMethod, RestService} from './rest.service';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class SequenceService {

  /**
   * Sequence of Employees and Owners
   * @private
   */
  private sequenceObject: any = {};

  /**
   * Sequence Behavior Subject of Employees and Owners
   * @private
   */
  private sequenceBehaviourSubject = new BehaviorSubject(null);

  constructor(private restService: RestService) {}

  /**
   * Gets the sequence of Employees and Owners by Facility Id
   * @param facilityId
   */
  getSequencesFromRemote(facilityId, endpoint) {
    this.restService.request<any>(RequestMethod.GET, endpoint, `${Actions.BASE_ACTIONS.READ}/sequence/${facilityId}`).subscribe(
      response => {
        if (response.success && response.data) {
          this.sequenceObject = response.data;
          this.updateSequence(this.sequenceObject);
        }
      }
    );
  }

  /**
   * Gets sequence as observable
   */
  getSequenceObservable() {
    return this.sequenceBehaviourSubject.asObservable();
  }

  /**
   * Updates sequence
   */
  updateSequence(sequenceObject) {
    this.sequenceBehaviourSubject.next(sequenceObject);
  }
}
